//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { BulkUploadSamplingProduct } from '@campaigns/types/sampling/SamplingBulkUploadTypes';

// Mapping of the fields in the bulk upload template to the labels used in the UI
export const FIELD_LABELS: Record<keyof BulkUploadSamplingProduct, string> = {
  // Base product fields
  name: 'Product name',
  targetCatalogProductId: 'Product ID',
  brand: 'Product brand',
  category: 'Product category',
  description: 'Product description',
  pdpUrl: 'PDP web address',
  imgUrl: 'Product image web address',
  shippingAvailabilityDate: 'Product availability date',
  destinationGTIN: 'UPCs for syndication',

  // Flattened dimensions fields (from dimensions array)
  dimensionsFormat: 'Dimension unit',
  dimensionsDepth: 'Product depth',
  dimensionsWidth: 'Product width',
  dimensionsHeight: 'Product height',

  // Flattened variant fields (from variations array)
  variantName: 'Variant name',
  variantImgUrl: 'Variant image web address',
  variantQuantity: 'Variant quantity',
  variantFairMarketValue: 'Variant FMV',
  variantLogisticsRef: 'Variant EAN/UPC',
} as const;
